"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: ledger/account-limits.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fledger%2Faccount-limits.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.transactionLimitLimitSourceToJSON = exports.transactionLimitLimitSourceFromJSON = exports.transactionLimitFilterToJSON = exports.transactionLimitFilterFromJSON = exports.TransactionLimitTransactionQuery = exports.TransactionLimit = exports.AssociatedAccountLimits = exports.AccountLimits = exports.TransactionLimitLimitSource = exports.TransactionLimitFilter = void 0;
const amount_1 = require("../common/amount");
const override_1 = require("../common/override");
const primary_account_type_1 = require("../common/primary-account-type");
const transaction_1 = require("./transaction");
const protobufPackage = 'com.step.common.proto';
var TransactionLimitFilter;
(function (TransactionLimitFilter) {
    TransactionLimitFilter["INVALID_TRANSACTION_LIMIT_FILTER"] = "INVALID_TRANSACTION_LIMIT_FILTER";
    TransactionLimitFilter["ALL_TRANSACTIONS"] = "ALL_TRANSACTIONS";
    TransactionLimitFilter["CREDIT_TRANSACTIONS"] = "CREDIT_TRANSACTIONS";
    TransactionLimitFilter["DEBIT_TRANSACTIONS"] = "DEBIT_TRANSACTIONS";
    TransactionLimitFilter["UNRECOGNIZED"] = "UNRECOGNIZED";
})(TransactionLimitFilter || (exports.TransactionLimitFilter = TransactionLimitFilter = {}));
var TransactionLimitLimitSource;
(function (TransactionLimitLimitSource) {
    TransactionLimitLimitSource["INVALID_LIMIT_SOURCE"] = "INVALID_LIMIT_SOURCE";
    TransactionLimitLimitSource["STEP"] = "STEP";
    TransactionLimitLimitSource["USER"] = "USER";
    TransactionLimitLimitSource["UNRECOGNIZED"] = "UNRECOGNIZED";
})(TransactionLimitLimitSource || (exports.TransactionLimitLimitSource = TransactionLimitLimitSource = {}));
function createBaseAccountLimits() {
    return {
        transactionLimits: [],
        minBalance: undefined,
        maxBalance: undefined,
        subAccountMinBalance: undefined,
    };
}
exports.AccountLimits = {
    fromJSON(object) {
        const message = {
            transactionLimits: globalThis.Array.isArray(object?.transactionLimits)
                ? object.transactionLimits.map((e) => exports.TransactionLimit.fromJSON(e))
                : [],
        };
        if (isSet(object.minBalance)) {
            message.minBalance = amount_1.Amount.fromJSON(object.minBalance);
        }
        if (isSet(object.maxBalance)) {
            message.maxBalance = amount_1.Amount.fromJSON(object.maxBalance);
        }
        if (isSet(object.subAccountMinBalance)) {
            message.subAccountMinBalance = amount_1.Amount.fromJSON(object.subAccountMinBalance);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transactionLimits?.length) {
            obj.transactionLimits = message.transactionLimits.map((e) => exports.TransactionLimit.toJSON(e));
        }
        if (message.minBalance !== undefined) {
            obj.minBalance = amount_1.Amount.toJSON(message.minBalance);
        }
        if (message.maxBalance !== undefined) {
            obj.maxBalance = amount_1.Amount.toJSON(message.maxBalance);
        }
        if (message.subAccountMinBalance !== undefined) {
            obj.subAccountMinBalance = amount_1.Amount.toJSON(message.subAccountMinBalance);
        }
        return obj;
    },
    create(base) {
        return exports.AccountLimits.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAccountLimits();
        message.transactionLimits =
            object.transactionLimits?.map((e) => exports.TransactionLimit.fromPartial(e)) || [];
        message.minBalance = (object.minBalance !== undefined && object.minBalance !== null)
            ? amount_1.Amount.fromPartial(object.minBalance)
            : undefined;
        message.maxBalance = (object.maxBalance !== undefined && object.maxBalance !== null)
            ? amount_1.Amount.fromPartial(object.maxBalance)
            : undefined;
        message.subAccountMinBalance =
            (object.subAccountMinBalance !== undefined && object.subAccountMinBalance !== null)
                ? amount_1.Amount.fromPartial(object.subAccountMinBalance)
                : undefined;
        return message;
    },
};
function createBaseAssociatedAccountLimits() {
    return {
        accountType: primary_account_type_1.PrimaryAccountType.INVALID_PRIMARY_ACCOUNT_TYPE,
        limits: exports.AccountLimits.fromPartial({}),
    };
}
exports.AssociatedAccountLimits = {
    fromJSON(object) {
        const message = {
            accountType: isSet(object.accountType)
                ? (0, primary_account_type_1.primaryAccountTypeFromJSON)(object.accountType)
                : primary_account_type_1.PrimaryAccountType.INVALID_PRIMARY_ACCOUNT_TYPE,
            limits: isSet(object.limits)
                ? exports.AccountLimits.fromJSON(object.limits)
                : exports.AccountLimits.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountType !== primary_account_type_1.PrimaryAccountType.INVALID_PRIMARY_ACCOUNT_TYPE) {
            obj.accountType = (0, primary_account_type_1.primaryAccountTypeToJSON)(message.accountType);
        }
        if (message.limits !== undefined) {
            obj.limits = exports.AccountLimits.toJSON(message.limits);
        }
        return obj;
    },
    create(base) {
        return exports.AssociatedAccountLimits.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAssociatedAccountLimits();
        message.accountType = object.accountType ?? primary_account_type_1.PrimaryAccountType.INVALID_PRIMARY_ACCOUNT_TYPE;
        message.limits = (object.limits !== undefined && object.limits !== null)
            ? exports.AccountLimits.fromPartial(object.limits)
            : exports.AccountLimits.fromPartial({});
        return message;
    },
};
function createBaseTransactionLimit() {
    return {
        id: '',
        queries: [],
        limit: amount_1.Amount.fromPartial({}),
        windowMs: '0',
        count: undefined,
        override: override_1.Override.INVALID_OVERRIDE,
        source: TransactionLimitLimitSource.INVALID_LIMIT_SOURCE,
        fractionalDisabled: false,
    };
}
exports.TransactionLimit = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            queries: globalThis.Array.isArray(object?.queries)
                ? object.queries.map((e) => exports.TransactionLimitTransactionQuery.fromJSON(e))
                : [],
            limit: isSet(object.limit) ? amount_1.Amount.fromJSON(object.limit) : amount_1.Amount.fromPartial({}),
        };
        if (isSet(object.windowMs)) {
            message.windowMs = globalThis.String(object.windowMs);
        }
        if (isSet(object.count)) {
            message.count = Number(object.count);
        }
        if (isSet(object.override)) {
            message.override = (0, override_1.overrideFromJSON)(object.override);
        }
        if (isSet(object.source)) {
            message.source = transactionLimitLimitSourceFromJSON(object.source);
        }
        if (isSet(object.fractionalDisabled)) {
            message.fractionalDisabled = globalThis.Boolean(object.fractionalDisabled);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.queries?.length) {
            obj.queries = message.queries.map((e) => exports.TransactionLimitTransactionQuery.toJSON(e));
        }
        if (message.limit !== undefined) {
            obj.limit = amount_1.Amount.toJSON(message.limit);
        }
        if (message.windowMs !== undefined && message.windowMs !== '0') {
            obj.windowMs = message.windowMs;
        }
        if (message.count !== undefined) {
            obj.count = message.count;
        }
        if (message.override !== undefined && message.override !== override_1.Override.INVALID_OVERRIDE) {
            obj.override = (0, override_1.overrideToJSON)(message.override);
        }
        if (message.source !== undefined &&
            message.source !== TransactionLimitLimitSource.INVALID_LIMIT_SOURCE) {
            obj.source = transactionLimitLimitSourceToJSON(message.source);
        }
        if (message.fractionalDisabled !== undefined && message.fractionalDisabled !== false) {
            obj.fractionalDisabled = message.fractionalDisabled;
        }
        return obj;
    },
    create(base) {
        return exports.TransactionLimit.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransactionLimit();
        message.id = object.id ?? '';
        message.queries = object.queries?.map((e) => exports.TransactionLimitTransactionQuery.fromPartial(e)) ||
            [];
        message.limit = (object.limit !== undefined && object.limit !== null)
            ? amount_1.Amount.fromPartial(object.limit)
            : amount_1.Amount.fromPartial({});
        message.windowMs = object.windowMs ?? '0';
        message.count = object.count ?? undefined;
        message.override = object.override ?? override_1.Override.INVALID_OVERRIDE;
        message.source = object.source ?? TransactionLimitLimitSource.INVALID_LIMIT_SOURCE;
        message.fractionalDisabled = object.fractionalDisabled ?? false;
        return message;
    },
};
function createBaseTransactionLimitTransactionQuery() {
    return {
        category: transaction_1.ControlCategory.INVALID_CONTROL_CATEGORY,
        filter: TransactionLimitFilter.INVALID_TRANSACTION_LIMIT_FILTER,
    };
}
exports.TransactionLimitTransactionQuery = {
    fromJSON(object) {
        const message = {
            category: isSet(object.category)
                ? (0, transaction_1.controlCategoryFromJSON)(object.category)
                : transaction_1.ControlCategory.INVALID_CONTROL_CATEGORY,
            filter: isSet(object.filter)
                ? transactionLimitFilterFromJSON(object.filter)
                : TransactionLimitFilter.INVALID_TRANSACTION_LIMIT_FILTER,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.category !== transaction_1.ControlCategory.INVALID_CONTROL_CATEGORY) {
            obj.category = (0, transaction_1.controlCategoryToJSON)(message.category);
        }
        if (message.filter !== TransactionLimitFilter.INVALID_TRANSACTION_LIMIT_FILTER) {
            obj.filter = transactionLimitFilterToJSON(message.filter);
        }
        return obj;
    },
    create(base) {
        return exports.TransactionLimitTransactionQuery.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransactionLimitTransactionQuery();
        message.category = object.category ?? transaction_1.ControlCategory.INVALID_CONTROL_CATEGORY;
        message.filter = object.filter ?? TransactionLimitFilter.INVALID_TRANSACTION_LIMIT_FILTER;
        return message;
    },
};
function transactionLimitFilterFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_TRANSACTION_LIMIT_FILTER':
            return TransactionLimitFilter.INVALID_TRANSACTION_LIMIT_FILTER;
        case 1:
        case 'ALL_TRANSACTIONS':
            return TransactionLimitFilter.ALL_TRANSACTIONS;
        case 2:
        case 'CREDIT_TRANSACTIONS':
            return TransactionLimitFilter.CREDIT_TRANSACTIONS;
        case 3:
        case 'DEBIT_TRANSACTIONS':
            return TransactionLimitFilter.DEBIT_TRANSACTIONS;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return TransactionLimitFilter.UNRECOGNIZED;
    }
}
exports.transactionLimitFilterFromJSON = transactionLimitFilterFromJSON;
function transactionLimitFilterToJSON(object) {
    switch (object) {
        case TransactionLimitFilter.INVALID_TRANSACTION_LIMIT_FILTER:
            return 'INVALID_TRANSACTION_LIMIT_FILTER';
        case TransactionLimitFilter.ALL_TRANSACTIONS:
            return 'ALL_TRANSACTIONS';
        case TransactionLimitFilter.CREDIT_TRANSACTIONS:
            return 'CREDIT_TRANSACTIONS';
        case TransactionLimitFilter.DEBIT_TRANSACTIONS:
            return 'DEBIT_TRANSACTIONS';
        case TransactionLimitFilter.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.transactionLimitFilterToJSON = transactionLimitFilterToJSON;
function transactionLimitLimitSourceFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_LIMIT_SOURCE':
            return TransactionLimitLimitSource.INVALID_LIMIT_SOURCE;
        case 1:
        case 'STEP':
            return TransactionLimitLimitSource.STEP;
        case 2:
        case 'USER':
            return TransactionLimitLimitSource.USER;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return TransactionLimitLimitSource.UNRECOGNIZED;
    }
}
exports.transactionLimitLimitSourceFromJSON = transactionLimitLimitSourceFromJSON;
function transactionLimitLimitSourceToJSON(object) {
    switch (object) {
        case TransactionLimitLimitSource.INVALID_LIMIT_SOURCE:
            return 'INVALID_LIMIT_SOURCE';
        case TransactionLimitLimitSource.STEP:
            return 'STEP';
        case TransactionLimitLimitSource.USER:
            return 'USER';
        case TransactionLimitLimitSource.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.transactionLimitLimitSourceToJSON = transactionLimitLimitSourceToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=account-limits.js.map